class UserClient {
    constructor(baseUrl, timeout) {
        this.__baseUrl = baseUrl;
        this.__timeout = timeout;
    }

    getLoggedUser() {
        return fetch(this.__baseUrl + "/user/loggedUser", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }

    logOut() {
        return fetch(this.__baseUrl + "/user/logOut", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }

    register(login, pass) {
        return fetch(this.__baseUrl + "/user/userRegistration", {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({login, pass}),
            signal: AbortSignal.timeout(this.__timeout) 
        })
    }
    
    login(login, pass) {
        return fetch(this.__baseUrl + "/user/loginAttempt", {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({login, pass}),
            signal: AbortSignal.timeout(this.__timeout) 
        })
    }
}

const userClient = new UserClient("./api", 8000);

export default userClient;